import { FINANCE_TABS, FINANCE_FUNCTIONS, resolveEexAccess, eexTabForPath, type EexCapabilities, type EexAccessOverrides } from "@chro/shared";
import type { AuthUser } from "../stores/auth";

export function eexCapabilitiesFor(user: AuthUser): EexCapabilities {
  if (user.eexCapabilities) return user.eexCapabilities;
  // Legacy sessions and fixtures carry the Finance grant lists. Real sessions
  // receive the resolved category/user permissions from the server.
  const overrides: EexAccessOverrides = { ...user.eexAccessOverrides };
  if (user.role === "finance") {
    for (const tab of FINANCE_TABS) overrides[`tab.${tab.id}`] = user.eexFinanceTabs?.includes(tab.id) ?? false;
    for (const action of FINANCE_FUNCTIONS) overrides[action.id] = user.eexFinanceFunctions?.includes(action.id) ?? false;
  }
  return resolveEexAccess(user.role, {}, overrides);
}
export function canAccessEexPath(user: AuthUser, path: string) {
  const tab = eexTabForPath(path);
  const capabilities = eexCapabilitiesFor(user);
  return !!tab && capabilities[`tab.${tab.id}`] && (tab.id !== "stats" || capabilities["tab.trades"]);
}
